module.exports = __webpack_public_path__ + "static/img/brandStory.4361ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/brandStory.png
// module id = EFCI
// module chunks = 0